import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c46269ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "main",
  class: "lightbox__heading mb-lg-40 text-center"
}, " Cultural Sensitivity Warning ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-center" }, " Aboriginal and Torres Strait Islanders are advised that the following website contains images of people who have passed, and images that may cause distress. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lightbox = _resolveComponent("Lightbox")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_Lightbox, {
      show: _ctx.show,
      minimal: "",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}